import { useMutation } from 'react-query'
import { useHistory } from 'react-router-dom'
import { routePaths } from 'global/routePaths'
import { endpoints } from 'global/endpoints'
import http from 'utils/http'
import { toast } from 'react-toastify'

const EditGoldAndSilver = ({ ...postData }) => {
  if (postData.id) {
    const updatedEndpoints = endpoints.goldorsilver.base
    return http('multipart').put(updatedEndpoints, postData)
  }
}

export function useEditGoldAndSilver() {
  const history = useHistory()

  return useMutation(EditGoldAndSilver, {
    onSuccess: () => {
      toast.success('Gold And Silver has been edited successfully')
      history.push(routePaths.home.goldSilver.base)
    },
    onError: (err) => {
      toast.error('Unfortunately, update of Gold And Silver was not successful.')
    },
  })
}
